/**
 * Promotions UI types — backend rows are mapped here by the page adapter.
 */

export interface PromotionItem {
  id: string;
  name: string;
  type: '% Discount' | 'Buy X Get Y' | 'Bundle' | 'Tier Override';
  conditions: string;
  tier: string;
  dateRange: string;
  used: number;
  status: 'Active' | 'Expired' | 'Scheduled' | 'Paused';
}

export const typeColors: Record<string, string> = {
  '% Discount': '#8B5CF6',
  'Buy X Get Y': '#10B981',
  'Bundle': '#3B82F6',
  'Tier Override': '#F59E0B',
};

export const statusColors: Record<string, string> = {
  Active: '#10B981',
  Expired: '#6B7280',
  Scheduled: '#3B82F6',
  Paused: '#F59E0B',
};

export const promoTypeOptions = ['% Discount', 'Buy X Get Y', 'Bundle', 'Tier Override'];
export const tierOptions = ['All', 'A', 'B', 'C', 'D', 'A, B', 'B, C', 'C, D'];
export const filterTypeOptions = promoTypeOptions;
export const filterStatusOptions = ['Active', 'Expired', 'Scheduled', 'Paused'];
export const filterTierOptions = ['All', 'A', 'B', 'C', 'D'];
